import React, { createContext, useContext, useEffect, useState } from 'react';
import { getGlobalSoundEnabled, setGlobalSoundEnabled } from '../utils/soundState';
import { soundEngine } from '../utils/soundEngine';

type SoundContextType = {
  soundEnabled: boolean;
  toggleSound: () => void;
  setSoundEnabled: (value: boolean) => void;
};

const SoundContext = createContext<SoundContextType>({
  soundEnabled: true,
  toggleSound: () => {},
  setSoundEnabled: () => {},
});


export const useSound = () => useContext(SoundContext);

export const SoundProvider = ({ children }: { children: React.ReactNode }) => {
  const [soundEnabled, setSoundEnabled] = useState(
    getGlobalSoundEnabled()
  );

  const toggleSound = () => setSoundEnabled(prev => !prev);

  useEffect(() => {
    setGlobalSoundEnabled(soundEnabled)
    soundEngine.setMasterVolume(soundEnabled ? 1 : 0)
  }, [soundEnabled])

  return (
    <SoundContext.Provider value={{ soundEnabled, toggleSound, setSoundEnabled }}>
      {children}
    </SoundContext.Provider>
  );
};

